"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
function useEventListener(eventType, handler, element = window) {
    const savedHandler = (0, react_1.useRef)(handler);
    (0, react_1.useEffect)(() => {
        savedHandler.current = handler;
    }, [handler]);
    (0, react_1.useEffect)(() => {
        if (!element) {
            return;
        }
        const eventListener = (event) => {
            savedHandler.current(event);
        };
        element.addEventListener(eventType, eventListener);
        return () => {
            element.removeEventListener(eventType, eventListener);
        };
    }, [eventType, element]);
}
exports.default = useEventListener;
